<template>
  <div class="Productdetail">
    <div class="wrapper-content">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>{{details.productName}}</h2>
        </div>
      </div>

      <div class="container productDetailsPage">
        <div class="product-right panel">
          <div class="row">
            <div class="col-md-5 col-sm-12">
              <div class="slide_bx">
                <img v-lazy="imageBaseUrl+details.image" />
              </div>
            </div>
            <div class="col-md-7 col-sm-12">
              <h2>{{details.productName}}</h2>
              <!-- <b-button v-on:click="isEdit=true" v-if="subscriptionStatus=='active'">Edit</b-button> -->
              <div class="price">{{currency}}{{details.price_per_unit}}/ {{details.product_unit}}</div>
              <p>
                {{ $t('message.Schedule') }} -
                <a
                  v-if="deliverySchedule.name=='MORN'"
                >Morning ({{deliverySchedule.delivery_timing_between}})</a>
              </p>
              <div
                class="line123456"
                v-if="deliverySchedule.next_delivery"
              >{{ $t('message.NextDelivery') }}:- {{deliverySchedule.next_delivery}}</div>
              <div class="deladd">
                <div class="border listbox">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="addressSelectBtn">
                        {{deliveryAddress.title}}: {{deliveryAddress.address}}, {{deliveryAddress.location}}
                        <img
                          class="nextIconImg"
                          src="../assets/images/next.svg"
                        />
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="quantity">
                <ul>
                  <li v-for="(item,index) in details.subscription_days" :key="index">
                    <label class="cust" v-if="item.day==1">{{ $t('message.Monday') }}</label>
                    <label class="cust" v-if="item.day==2">{{ $t('message.Tuesday') }}</label>
                    <label class="cust" v-if="item.day==3">{{ $t('message.Wednesday') }}</label>
                    <label class="cust" v-if="item.day==4">{{ $t('message.Thursday') }}</label>
                    <label class="cust" v-if="item.day==5">{{ $t('message.Friday') }}</label>
                    <label class="cust" v-if="item.day==6">{{ $t('message.Saturday') }}</label>
                    <label class="cust" v-if="item.day==7">{{ $t('message.Sunday') }}</label>
                    <div class="qty_dv">
                      <b-input-group>
                        <b-input-group-prepend v-if="isEdit">
                          <b-btn variant="info" @click="item.quantity--">-</b-btn>
                        </b-input-group-prepend>
                        <b-form-input type="number" min="0" v-model="item.quantity"></b-form-input>
                        <b-input-group-append v-if="isEdit">
                          <b-btn variant="info" @click="item.quantity++">+</b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                  </li>
                </ul>
              </div>

              <!-- <div class="total_amt">
                {{ $t('message.Total') }}
                <span>{{currency}}{{details.subscriptionTotalPrice}}</span>
              </div>-->
              <div v-if="subscriptionStatus=='active'">
                <div class="btn_rw" v-if="isEdit">
                  <a
                    id="next"
                    class="btn btn-primary cancel"
                    v-on:click="activateSubs"
                  >{{ $t('message.NextBtn') }}</a>
                </div>
                <div class="btn_rw" v-else>
                  <a
                    v-b-modal.pause-subs
                    id="pause"
                    class="btn btn-primary pause"
                  >{{ $t('message.PauseSubs') }}</a>
                  <a
                    v-b-modal.cancel-subs
                    id="cancel"
                    class="btn btn-primary cancel cancel-new"
                  >{{ $t('message.CancelSubs') }} {{ $t('message.Subscriptions') }}</a>
                </div>
              </div>
              <div v-else-if="subscriptionStatus=='paused'">
                <div class="btn_rw" v-if="isEdit">
                  <a
                    id="next"
                    class="btn btn-primary cancel"
                    v-on:click="activateSubs"
                  >{{ $t('message.NextBtn') }}</a>
                </div>
                <div class="btn_rw" v-else>
                  <a
                    id="pause"
                    class="btn btn-primary pause"
                    v-on:click="isEdit=true"
                  >{{ $t('message.Active') }}</a>
                  <a
                    v-b-modal.cancel-subs
                    id="cancel"
                    class="btn btn-primary cancel"
                  >{{ $t('message.CancelSubs') }} {{ $t('message.Subscriptions') }}</a>
                </div>
              </div>
              <div v-else>
                <div class="btn_rw" v-if="isEdit">
                  <a
                    id="next"
                    class="btn btn-primary cancel"
                    v-on:click="activateSubs"
                  >{{ $t('message.NextBtn') }}</a>
                </div>
                <div class="btn_rw" v-else>
                  <a
                    id="pause"
                    class="btn btn-primary pause"
                    v-on:click="isEdit=true"
                  >{{ $t('message.Active') }}</a>
                </div>
              </div>
              <b-modal id="pause-subs" hide-footer>
                <template
                  v-slot:modal-title
                >{{ $t('message.PauseSubs') }} {{ $t('message.Subscriptions') }}</template>
                <div class="d-block text-center">
                  <p>{{ $t('message.PauseSubConfirm') }}</p>
                </div>
                <div class="btnrw">
                  <a
                    class="btn btn-secondary"
                    block
                    @click="$bvModal.hide('pause-subs')"
                  >{{ $t('message.NoButton') }}</a>
                  <a
                    v-on:click="SubscriptionStatus('pause')"
                    class="btn btn-secondary"
                    block
                  >{{ $t('message.YesButton') }}</a>
                </div>
              </b-modal>
              <b-modal id="cancel-subs" hide-footer>
                <template
                  v-slot:modal-title
                >{{ $t('message.CancelSubs') }} {{ $t('message.Subscriptions') }}</template>
                <div class="d-block text-center">
                  <p>{{ $t('message.CancelSubConfirm') }}</p>
                </div>
                <div class="btnrw">
                  <a
                    class="btn btn-secondary"
                    block
                    @click="$bvModal.hide('cancel-subs')"
                  >{{ $t('message.NoButton') }}</a>
                  <a
                    v-on:click="SubscriptionStatus('cancel')"
                    class="btn btn-secondary"
                    block
                  >{{ $t('message.YesButton') }}</a>
                </div>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { changeSubscriptionsStatus } from "./../services/api";
import Datepicker from "vuejs-datepicker";
import "../../node_modules/vue-slick-carousel/dist/vue-slick-carousel.css";
import "../../node_modules/vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import VueSlickCarousel from "vue-slick-carousel";
import VueLazyload from "vue-lazyload";
import Vue from "vue";
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: "giphy.gif",
  attempt: 1
});
export default {
  name: "product",
  components: {
    Datepicker,
    VueSlickCarousel
  },
  data() {
    return {
      currency: localStorage.getItem("CurrencySymbol"),
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      details: "",
      deliverySchedule: "",
      deliveryAddress: "",
      isEdit: false,
      subscriptionStatus: ""
    };
  },
  created() {
    if (!localStorage.getItem("userName")) {
      localStorage.clear();
      this.$router.push({ name: "register" });
    } else {
      this.details = JSON.parse(localStorage.getItem("productSubscribed"));      
      this.subscriptionStatus = localStorage.getItem("subscriptionStatus");
      this.deliverySchedule = this.details.deliverySchduleTimig[0];
      this.deliveryAddress = this.details.addresses;
    }
  },
  methods: {
    activateSubs() {
      localStorage.setItem("productSubscribed", JSON.stringify(this.details));
      this.$router.replace({ name: "activate-subscription" });
    },

    SubscriptionStatus(status) {
      if (status == "pause") {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          subscription_id: this.details.subscriptionId,
          product_id: this.details.productId,
          status: "paused",
          vendor_id: localStorage.getItem("vendorId"),
          token: localStorage.getItem("token")
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          subscription_id: this.details.subscriptionId,
          product_id: this.details.productId,
          status: "cancel",
          vendor_id: localStorage.getItem("vendorId"),
          token: localStorage.getItem("token")
        };
      }

      changeSubscriptionsStatus(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            console.log("subs", result);
            if (status == "pause") {
              this.$router.push({ name: "subcription", query: { ti: 1 } });
            } else {
              this.$router.push({ name: "subcription", query: { ti: 2 } });
            }
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    }
  }
};
</script>
